import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const RepondreAvis = async (data) => {
  return await axios.post(`${BASE_URL}/api/restaurant/repondreAvis`, data, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}
const AfficheAvisNote = async (idRestaurant,page) => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheAvis/${idRestaurant}/${page}`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}


export { AfficheAvisNote, RepondreAvis }